import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 25 16",
  "content": "<symbol viewBox=\"0 0 25 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n<path d=\"M10.6074 15.5566L9.19321 14.1424L21.9211 1.41451L24.7496 1.41451L10.6074 15.5566Z\" />\n<path d=\"M9.19336 11.3135L7.77915 12.7277L0.000971377 4.94952L2.8294 4.94952L9.19336 11.3135Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol